import { render, staticRenderFns } from "./roundedRectangleBalloon.vue?vue&type=template&id=6d817aa6&"
import script from "./roundedRectangleBalloon.vue?vue&type=script&lang=ts&"
export * from "./roundedRectangleBalloon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports